
import { Constant } from "@/helpers/constant";
import { DropdownData } from "@/helpers/dropdownData";
import Jobseeker from "@/models/jobseeker";
import JobseekerConditionalQuestionsTemp from '@/models/jobseekerConditionalQuestionsTemp';
import JobseekerEducation from "@/models/jobseekerEducation";
import JobseekerEmployment from "@/models/jobseekerEmployment";
import { Component, Vue } from "vue-property-decorator";
import JobseekerService from "../../../../services/jobseekerService";
import UpSkillService from "../../../../services/upSkillService";
import { TranslateMalay } from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";
import JobseekerEmploymentsTemp from "@/models/jobseekerEmploymentsTemp";
import JobseekerEducationsTemp from "@/models/jobseekerEducationsTemp";
import JobseekerCareerProfileTemp from "@/models/jobseekerCareerProfileTemp";
import JobseekerPersonalDetailsTemp from "@/models/jobseekerPersonalDetailsTemp";

import CryptoJS from "crypto-js";
import { InternationalPhoneCode } from "@/helpers/internationalPhoneCode";

@Component
export default class JobseekerPreReg extends Vue {
  year = DropdownData.years;
  month = DropdownData.months;
  keySkills = DropdownData.skills;
  jobseekerCurrentStatus = DropdownData.jobseekerCurrentStatus;
  jobseeker: Jobseeker = new Jobseeker();
  submitted = false;
  passwordMismatcherror = false;
  $loading: any;
  emailExists = false;
  termsAndConditions = [];
  currentLocationDetails = [];
  servingNoticePeriod = [];
  passwordSwitch = "password";
  confirmPasswordSwitch = "password";
  icNoExists = false;
  fresher = "";
  displayConfirmation = false;
  skills = [];
  skillArr = [];
  reqjobseeker = new FormData();
  conditionalQuestions = [];
  jobseekerConditionalQuestions: JobseekerConditionalQuestionsTemp[] = [];
  jobseekerId: number = null;
  questionError: boolean = false;
  selectedLanguage: string = '';
  jobseekerSignupFormData: any;
  fresherStatus = false;
  retrenchedStatus: boolean = false;
  jobseekerProfileFormData: any;
  step = 1;
  desiredCareerProfileData: any;
  industryList: any;
  departmentList: any;
  workPositions: any;

  // for Employment
  employmentformData: any;
  jobseekerEmployment: JobseekerEmploymentsTemp = new JobseekerEmploymentsTemp();
  options = ["Malaysian Ringgit"];
  roles = DropdownData.roles;
  jobCategories = DropdownData.jobCategories;
  positionLevels = DropdownData.positionLevels;
  jobTypes = DropdownData.jobTypes;
  states = DropdownData.stateList;
  industries = DropdownData.jobseekerIdustries;
  specializations = DropdownData.specializations;
  specializationSubCategoriesEmployment = [];
  skillsListingData: any = [];
  notice = [
    { label: "15 Days or less", value: "15 Days or less" },
    { label: "1 Month", value: "1 Month" },
    { label: "2 Months", value: "2 Months" },
    { label: "3 Months", value: "3 Months" },
    { label: "More Than 3 Months", value: "More Than 3 Months" },
  ];

  // For Education
  yearsof = [
    { label: "2010", value: "2010" },
    { label: "2011", value: "2011" },
    { label: "2012", value: "2012" },
    { label: "2013", value: "2013" },
    { label: "2014", value: "2014" },
    { label: "2015", value: "2015" },
    { label: "2016", value: "2016" },
    { label: "2017", value: "2017" },
    { label: "2018", value: "2018" },
    { label: "2019", value: "2019" },
  ];
  courses = DropdownData.fieldOfStudy;
  gradingList = [
    { label: "Scale 10 Grading System", value: "Scale 10 Grading System" },
    { label: "Scale 4 Grading System", value: "Scale 4 Grading System" },
    { label: "% Marks of 100 Maximum", value: "% Marks of 100 Maximum" },
    { label: "Course Requires a Pass", value: "Course Requires a Pass" },
  ];
  qualifications = DropdownData.qualifications;
  qualificationSubCategories = [];
  specializationSubCategories = [];
  jobseekerEducation: JobseekerEducationsTemp = new JobseekerEducationsTemp();
  courseTypeOptions = ["Full time", "Part time", "Distance Learning"];
  educationFormData: any;
  popuptext: any;


  // For Personal Detail
  status = [
    { label: "Single/unmarried", value: "Single/unmarried" },
    { label: "Married", value: "Married" },
    { label: "Widowed", value: "Widowed" },
    { label: "Divorced", value: "Divorced" },
    { label: "Separated", value: "Separated" },
    { label: "Other", value: "Other" },
  ];
  typesOfAbled = [
    { label: "Blindness", value: "Blindness" },
    { label: "Low Vision", value: "Low Vision" },
    {
      label: "Speech and Language Disability",
      value: "Speech and Language Disability",
    },
    { label: "Hearing Impairment", value: "Hearing Impairment" },
    { label: "Locomotor Disability", value: "Locomotor Disability" },
  ];
  jobseekerPersonalDetails: JobseekerPersonalDetailsTemp = new JobseekerPersonalDetailsTemp();
  ethnicities = DropdownData.ethnicities;
  yesterday = null;
  personalDetailsData: any = TranslateEn.personaldetailtext;
  mandatorycheck: any = true;
  eventSpecificInformation: any = [];
  identificationOfEmployment: any = [];
  identificationOfOrganisation: any = [];
  intlPhoneCodeList: any = [];
  countryList: any = [];
  showPassport: any = 0;
  errors: any;
  //otherCountry:any;

  created() {
    this.getConditionalQuestions();
    this.getAllSkills();
    this.getCountry();
    // For Employment
    this.selectedLanguage = localStorage.getItem("selectedlanguage");
    this.jobseekerEmployment.salary_type = "Malaysian Ringgit";
    this.jobseekerEmployment.is_current_company = "No";
    if (
      this.jobseekerEmployment.is_current_company == undefined ||
      this.jobseekerEmployment.is_current_company == null
    ) {
      this.jobseekerEmployment.is_current_company = "No";
    }
    if (
      this.jobseekerEmployment.salary_type == undefined ||
      this.jobseekerEmployment.salary_type == null
    ) {
      this.jobseekerEmployment.salary_type = "Malaysian Ringgit";
    }
    // For Education
    this.jobseekerEducation.course_type = "Full time";

    // For Personal Detail
    const today = new Date();
    this.yesterday = new Date(today);
    this.yesterday.setDate(this.yesterday.getDate() - 1);


    this.selectedLanguage = localStorage.getItem("selectedlanguage");

    if (this.selectedLanguage == 'en') {
      this.jobseekerSignupFormData = TranslateEn.jobseekerSignupFormData;
      this.jobseekerProfileFormData = TranslateEn.jobSeekerProfile;
      // For Employment
      this.employmentformData = TranslateEn.employmentformText;
      // For Education
      this.educationFormData = TranslateEn.educationformText;
      this.courseTypeOptions = ["Full time", "Part time", "Distance Learning"];
      // For Personal Detail
      this.personalDetailsData = TranslateEn.personaldetailtext;
      this.jobCategories = DropdownData.jobCategories;
      this.positionLevels = DropdownData.positionLevels;
      this.jobTypes = DropdownData.jobTypes;
      this.industries = DropdownData.jobseekerIdustries;
      this.specializations = DropdownData.specializations;
      this.qualifications = DropdownData.qualifications;
      this.industryList = DropdownData.jobseekerIdustries;
      this.departmentList = DropdownData.departmentList;
      this.workPositions = DropdownData.positionLevels;
      this.popuptext = TranslateEn.popupText;
      this.eventSpecificInformation = DropdownData.eventSpecificInformation;
      this.identificationOfEmployment = DropdownData.identificationOfEmployment;
      this.identificationOfOrganisation = DropdownData.identificationOfOrganisation;
      this.options = ["Malaysian Ringgit"];
      this.intlPhoneCodeList = InternationalPhoneCode.intlPhoneCodes;
    }
    else {
      this.jobseekerSignupFormData = TranslateMalay.jobseekerSignupFormData;
      this.jobseekerProfileFormData = TranslateMalay.jobSeekerProfile;
      // For Employment
      this.employmentformData = TranslateMalay.employmentformText;
      // For Education
      this.educationFormData = TranslateMalay.educationformText;
      this.courseTypeOptions = ["Sepenuh Masa", "Separa Masa", "Jarak Jauh"];
      // For Personal Detail
      this.personalDetailsData = TranslateMalay.personaldetailtext;
      this.jobCategories = DropdownData.jobCategoriesInMalay;
      this.positionLevels = DropdownData.positionLevelsInMalay;
      this.jobTypes = DropdownData.jobTypesInMalay;
      this.industries = DropdownData.jobseekerIdustriesInMalay;
      this.specializations = DropdownData.specializationsInMalay;
      this.qualifications = DropdownData.qualificationsInMalay;
      this.industryList = DropdownData.jobseekerIdustriesInMalay;
      this.departmentList = DropdownData.departmentListInMalay;
      this.workPositions = DropdownData.positionLevelsInMalay;
      this.popuptext = TranslateMalay.popupText;
      this.eventSpecificInformation = DropdownData.eventSpecificInformation;
      this.identificationOfEmployment = DropdownData.identificationOfEmployment;
      this.identificationOfOrganisation = DropdownData.identificationOfOrganisation;
      this.options = ["Ringgit Malaysian"];
      this.intlPhoneCodeList = InternationalPhoneCode.intlPhoneCodes;
    }

    this.retrenchedFlagCheck();
  }

  formatIcDash(){
      
      // Remove all '-' first
      //let raw = value.value.replace(/-/g, '')
      let icnum = this.jobseeker.icNumber.replace(/-/g, '');

      // Insert '-' after 4 characters
      if (icnum.length > 6) {
        icnum = icnum.slice(0, 6) + '-' + icnum.slice(6)
      }

      if (icnum.length > 9) {
        icnum = icnum.slice(0, 9) + '-' + icnum.slice(9)
      }

      this.jobseeker.icNumber = icnum;
    
  }

  onNationalityChange(event) {
    if (event.target.value == '1') { //local
      this.showPassport = 0;
      this.jobseeker.state = '';
    } else {
      this.showPassport = 1;
      this.jobseeker.state = 'Others';
    }
  }

  getConditionalQuestions() {
    let loader = this.$loading.show();
    UpSkillService.getConditionalQuestions().then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.data.statusCode == 200) {
          if (
            response.data.data != undefined &&
            response.data.data != null &&
            response.data.data.data != undefined &&
            response.data.data.data.length > 0
          ) {
            this.conditionalQuestions = response.data.data.data;
          }
        }
      }
    });
  }
  chooseQuestions(value, questions) {
    if (value != "null") {
      let options = questions.options.filter((x) => x.id == value);
      let conditionalQuestion = new JobseekerConditionalQuestionsTemp();
      conditionalQuestion.question_id = questions.id;
      conditionalQuestion.question_name = questions.name;
      conditionalQuestion.option_name = options[0].options;
      conditionalQuestion.option_id = options[0].id;
      let count = 0;
      if (this.jobseekerConditionalQuestions.length > 0) {
        this.jobseekerConditionalQuestions.forEach((element, index) => {
          if (element.question_id == questions.id) {
            this.jobseekerConditionalQuestions[index].question_name =
              questions.name;
            this.jobseekerConditionalQuestions[index].option_name =
              options[0].options;
            this.jobseekerConditionalQuestions[index].option_id = options[0].id;
            count = 1;
          }
        });
        if (count == 0) {
          this.jobseekerConditionalQuestions.push(conditionalQuestion);
        }
      } else {
        this.jobseekerConditionalQuestions.push(conditionalQuestion);
      }
    }
  }
  switchPasswordType() {
    this.passwordSwitch =
      this.passwordSwitch === "password" ? "text" : "password";
  }

  switchConfirmPasswordType() {
    this.confirmPasswordSwitch =
      this.confirmPasswordSwitch === "password" ? "text" : "password";
  }

  checkEmailIfExists() {
    this.emailExists = false;
    if (
      this.jobseeker.email != undefined &&
      this.jobseeker.email != null &&
      this.jobseeker.email != ""
    ) {
      this.jobseeker.email = this.jobseeker.email.toLowerCase().trim();
      let loader = this.$loading.show();
      JobseekerService.checkValueExists(this.jobseeker.email, "email").then(
        (response) => {
          loader.hide();
          if (
            response != undefined &&
            response.data != undefined &&
            response.data.status != undefined
          ) {
            if (response.data.status == 200) {
              if (
                response.data.data != undefined &&
                response.data.data != null
              ) {
                if (response.data.data.length > 0) {
                  this.emailExists = true;
                } else {
                  this.emailExists = false;
                }
              }
            }
          }
        }
      );
    }
  }

  checkICNumberExists() {
    
    // this.formatIcDash();
    this.icNoExists = false;
    if (
      this.jobseeker.icNumber != undefined &&
      this.jobseeker.icNumber != null &&
      this.jobseeker.icNumber != ""
    ) {
      let loader = this.$loading.show();
      JobseekerService.checkValueExists(
        this.jobseeker.icNumber,
        "ic_number"
      ).then((response) => {
        loader.hide();
        if (
          response != undefined &&
          response.data != undefined &&
          response.data.status != undefined
        ) {
          if (response.data.status == 200) {
            if (response.data.data != undefined && response.data.data != null) {
              if (response.data.data.length > 0) {
                this.icNoExists = true;
               
              
              } else {
                this.icNoExists = false;
              }
            }
          }
        }
      });
    }
  }

  openConfirmDialog() {
    this.questionError = false;
    if (
      this.emailExists == false &&
      this.icNoExists == false &&
      this.questionError == false
    ) {
      this.submitted = true;
      this.passwordMismatcherror = false;
      if (
        this.termsAndConditions != undefined ||
        this.termsAndConditions != null
      ) {
        this.jobseeker.termsAndConditions = this.termsAndConditions.toString();
      }
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.jobseekerConditionalQuestions.length <= 0) {
            this.questionError = true;
            return;
          }
          if (this.jobseeker.password == this.jobseeker.confirmPassword) {
            this.displayConfirmation = true;
            this.submitted = false;
          } else {
            this.passwordMismatcherror = true;
          }
        }
      });
    }
  }
  cancelConfirmation() {
    this.displayConfirmation = false;
  }
  
  async acceptConfirmation() {
    
    this.displayConfirmation = false;
    
    // run validation properly (WAIT for result)
    const isValid = await this.$validator.validateAll();

if (!isValid) {
  const invalidFields = this.errors.items.map(e => e.field);
  console.log(invalidFields);
}
    // stop if validation fails
    if (!isValid) {
      this.$fire({
        title: 'Error',
        text: "Please check if all the fields are entered correctly.",
        confirmButtonText: 'OK',
        type: "error"
      });
      return;
    }

    // extra validation (password match)
    if (this.jobseeker.password !== this.jobseeker.confirmPassword) {
      this.$fire({
        title: 'Error',
        text: "Password and Confirm Password do not match.",
        confirmButtonText: 'OK',
        type: "error"
      });
      return;
    }

    let loader = this.$loading.show();

    try {
      // normalize data
      this.jobseeker.email = this.jobseeker.email.toLowerCase().trim();
      this.jobseeker.status = Constant.ACTIVE;
      this.jobseeker.roleType = Constant.JOBSEEKER_ROLE;

      // encrypt password
      const encrypt = (value) => {
        return CryptoJS.AES.encrypt(
          value,
          CryptoJS.enc.Utf8.parse(Constant.AES_ENCRYPTION_KEY),
          {
            iv: CryptoJS.enc.Utf8.parse(Constant.ENCRYPT_IV),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
          }
        ).toString();
      };

      this.jobseeker.password = encrypt(this.jobseeker.password);
      this.jobseeker.confirmPassword = encrypt(this.jobseeker.confirmPassword);

      // helper: camelCase → snake_case
      const strToSnakeCase = (key) =>
        key &&
        key
          .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
          .map((x) => x.toLowerCase())
          .join("_");

      // reset FormData
      this.reqjobseeker = new FormData();

      // append data
      for (let key in this.jobseeker) {
        const value = this.jobseeker[key];

        if (value !== undefined && value !== null) {
          if (
            key === 'jobseekerEmploymentsTemp' ||
            key === 'jobseekerEducationsTemp' ||
            key === 'jobseekerPersonalDetailsTemp'
          ) {
            continue;
          }

          this.reqjobseeker.append(strToSnakeCase(key), value);
        }
      }

      /**To get url params */
      let courseId = ''
      this.reqjobseeker.append('courseId','123')
      // append additional data
      this.reqjobseeker.append(
        "conditionalquestions",
        JSON.stringify(this.jobseekerConditionalQuestions)
      );
      this.reqjobseeker.append("provider", Constant.JOBSEEKER_PROVIDER);

      // API call
      const response = await JobseekerService.createJobseeker(
        this.reqjobseeker,
        Constant.JOBSEEKER_PROVIDER
      );

      loader.hide();

      if (response?.data?.status === 200) {
        this.jobseeker = response.data.data;
        this.jobseekerId = response.data.data.id;

        this.$fire({
          title: 'Success',
          text: "Your Registration has been done Successfully.",
          confirmButtonText: 'OK',
          type: "success"
        });

        localStorage.setItem("loginType", "");
        this.$router.push("/individualLogin");
        this.submitted = false;
      } else {
        throw new Error("API failed");
      }

    } catch (err) {
      loader.hide();

      this.$fire({
        title: 'Error',
        text: "Something went wrong. Please try again.",
        confirmButtonText: 'OK',
        type: "error"
      });

      this.submitted = false;
      this.jobseeker = new Jobseeker();
      this.reqjobseeker = new FormData();
      this.jobseekerConditionalQuestions = [];
    }
  }

  cancel() {
    this.$router.push("/individualLogin");
  }
  onUpload(event) {
    for (const file of event.files) {
      let fileNameArray = file.name.split(".");
      if (file.size >= 1097152) {
        alert("File size is exceed");
      } else if (fileNameArray[fileNameArray.length - 1] != "pdf") {
        alert("Resume accepts only pdf file format");
      } else {
        this.jobseeker.resumeFileName = file.name;
        this.reqjobseeker.append("file", file);
      }
    }
  }
  viewPrivacyPolicy() {
    let route = this.$router.resolve({ path: "/privacyPolicy" });
    window.open(route.href, "_blank");
  }
  // addSkills() {
  //   if (this.skills != "") {
  //     console.log(this.skills)
  //     let separators = [",", " And ", " and "];
  //     this.skillArr = this.skills.split(new RegExp(separators.join("|")));
  //     let jobseekerSkills = [];
  //     if (
  //       this.jobseeker.keySkills != undefined &&
  //       this.jobseeker.keySkills != null &&
  //       this.jobseeker.keySkills != ""
  //     ) {
  //       jobseekerSkills = this.jobseeker.keySkills.split(",");
  //     }
  //     this.skillArr.forEach((element) => {
  //       let skill = element.trim().toLowerCase();
  //       if (jobseekerSkills.includes(skill) == false && skill != "") {
  //         jobseekerSkills.push(skill);
  //       }
  //     });
  //     this.jobseeker.keySkills = jobseekerSkills.join(",");
  //   }
  //   this.skills = "";
  // }
  removeSkills(index) {
    let skills = this.jobseeker.keySkills.split(",");
    skills.splice(index, 1);
    this.jobseeker.keySkills = skills.join(",");
  }
  skilArr: any = []
  addedSkills: any = []
  //    addSkill() {
  //     if (this.skills != "") {
  //       this.skilArr.push(this.skills)
  //     this.skillArr = [...new Set(this.skilArr)];
  //      this.jobseeker.keySkills = this.skillArr.toString();
  //      console.log(JSON.stringify(this.skillArr))
  //  this.addedSkills =  this.skillsListingData.filter(o1 => this.skillArr.some(o2 => o1.id === o2));
  //       }
  //     this.skills = "";
  //   }
  // removeSkill(id,index) {
  //   this.addedSkills = this.addedSkills.slice(index, 1);
  //    this.skillArr =  this.skillArr.filter(o1 => o1 != id);
  //    console.log(this.skillArr)
  //    this.jobseeker.keySkills = this.skillArr.toString();

  //   console.log(JSON.stringify(this.jobseeker.keySkills))
  // }

  skillSelected(event){ 
      this.jobseeker.keySkills = this.skills.toString();
      
  }

  splitAndJoinKeySkills(keySkills) {
    return keySkills.split(",");
  }

  next() {
    if (this.step == 1) {
      this.questionError = false;
      if (
        this.emailExists == false &&
        this.icNoExists == false &&
        this.questionError == false
      ) {
        this.submitted = true;
        this.passwordMismatcherror = false;
        if (
          this.termsAndConditions != undefined ||
          this.termsAndConditions != null
        ) {
          this.jobseeker.termsAndConditions = this.termsAndConditions.toString();
        }
        this.$validator.validate().then((valid) => {
          if (valid) {
            if (this.jobseekerConditionalQuestions.length <= 0) {
              this.questionError = true;
              return;
            }
            if (this.jobseeker.password == this.jobseeker.confirmPassword) {
              if (this.fresherStatus == true) {
                // this.step += 2;
              } else {
                // //this.step++;
              }
              this.submitted = false;
            } else {
              this.passwordMismatcherror = true;
            }
          }
        });
        this.step = 1;
        this.displayConfirmation = true;
      }
    } else if (this.step == 2) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.submitted = false;
          //this.step++;
          let employmentArray = [];
          employmentArray.push(this.jobseekerEmployment);
          this.jobseeker.jobseekerEmploymentsTemp = employmentArray;
          this.reqjobseeker.append("jobseeker_employments_temp", JSON.stringify(this.jobseeker.jobseekerEmploymentsTemp));
          return;
        }
      });
    } else if (this.step == 3) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.submitted = false;
          //this.step++;
          let educationArray = [];
          educationArray.push(this.jobseekerEducation);
          this.jobseeker.jobseekerEducationsTemp = educationArray;
          this.reqjobseeker.append("jobseeker_educations_temp", JSON.stringify(this.jobseeker.jobseekerEducationsTemp));
          return;
        }
      });
    } else if (this.step == 4) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.submitted = false;
          let personalDetailArray = [];
          personalDetailArray.push(this.jobseekerPersonalDetails);
          this.jobseeker.jobseekerPersonalDetailsTemp = personalDetailArray;
          this.reqjobseeker.append("jobseeker_personal_details_temp", JSON.stringify(this.jobseeker.jobseekerPersonalDetailsTemp));
          this.displayConfirmation = true;
          return;
        }
      });
    }
  }

  changeexperience() {
    if (this.fresherStatus == false) {
      this.jobseeker.totalWorkExperienceInYrs = 0;
      this.jobseeker.totalWorkExperienceInMonths = 0;
    } else {
      this.jobseeker.totalWorkExperienceInYrs = null;
      this.jobseeker.totalWorkExperienceInMonths = null;

    }
  }

  retrenchedFlagCheck() {
    if (this.retrenchedStatus == false) {
      this.jobseeker.retrenched_flag = 0;
    } else {
      this.jobseeker.retrenched_flag = 1;
    }
    console.log(this.retrenchedStatus + "" + this.jobseeker.retrenched_flag)
  }
  // For Employment Starts
  chooseSpecializationEmployment() {
    this.specializationSubCategoriesEmployment = [];
    if (this.jobseekerEmployment.specialization == "Accounting/Finance") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.accountingFinance;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.accountingFinanceInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Banking/ Financial") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.bankingFinancial;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.bankingFinancialInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Corporate Finance/ Investment"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.corporateFinance;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.corporateFinanceInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "General/ Cost Accounting"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.costAccounting;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.costAccountingInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Admin/Human Resources"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.humanResources;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.humanResourcesInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Advertising") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.advertising;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.advertisingInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Art/Creative Design"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.creativeDesign;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.creativeDesignInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Civil Engineering/Construction"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.civilEngineering;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.civilEngineeringInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Property/Real Estate"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.realEstate;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.realEstateInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "IT-Network/System/DB Admin"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.itNetwork;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.itNetworkInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "IT-Software") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.itSoftware;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.itSoftwareInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Education") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.education;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.educationInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Electrical Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.electricalEngineering;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.electricalEngineeringInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Electronic Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.electronicEngineering;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.electronicEngineeringInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization ==
      "Mechanical/Automotive Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.automotiveEngineering;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.automotiveEngineeringInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Oil/Gas Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.oilGasEngineering;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.oilGasEngineeringInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Nurse/Medical Support"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.medicalSupport;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.medicalSupportInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Food/Beverage/Restaurant"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.beverageRestaurant;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.beverageRestaurantInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Hotel/Tourism") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.hotelTourism;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.hotelTourismInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Maintenance") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.maintenance;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.maintenanceInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Manufacturing") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.manufacturing;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.manufacturingInMalay;
      }
    } else if (
      this.jobseekerEmployment.specialization == "Purchasing/Material Management"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.materialManagement;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.materialManagementInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Digital Marketing") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.digitalMarketing;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.digitalMarketingInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "E-commerce") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.eCommerce;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.eCommerceInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Biomedical") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.biomedical;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.biomedicalInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "Law/Legal Services") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.lawLegalServices;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.lawLegalServicesInMalay;
      }
    } else if (this.jobseekerEmployment.specialization == "General Work") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategoriesEmployment = DropdownData.generalWork;
      } else {
        this.specializationSubCategoriesEmployment = DropdownData.generalWorkInMalay;
      }
    }
  }

  // For Education Starts
  chooseQualification() {
    this.qualificationSubCategories = [];
    if (this.jobseekerEducation.qualification == "No Formal Education") {
      this.mandatorycheck = false;
      if (this.selectedLanguage == "en") {
        this.qualificationSubCategories = DropdownData.noFormalEducation;
      } else {
        this.qualificationSubCategories = DropdownData.noFormalEducationInMalay;
      }
    } else if (this.jobseekerEducation.qualification == "Primary") {
      this.mandatorycheck = true;
      this.qualificationSubCategories = DropdownData.primary;
    } else if (this.jobseekerEducation.qualification == "Secondary") {
      this.mandatorycheck = true;
      this.qualificationSubCategories = DropdownData.secondary;
    } else if (this.jobseekerEducation.qualification == "Tertiary") {
      this.mandatorycheck = true;
      if (this.selectedLanguage == "en") {
        this.qualificationSubCategories = DropdownData.tertiary;
      } else {

        this.qualificationSubCategories = DropdownData.tertiaryInMalay;
      }

    }
  }

  chooseSpecialization() {
    this.specializationSubCategories = [];
    if (this.jobseekerEducation.specialization == "Accounting/Finance") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.accountingFinance;
      } else {
        this.specializationSubCategories = DropdownData.accountingFinanceInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Banking/ Financial") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.bankingFinancial;
      } else {
        this.specializationSubCategories = DropdownData.bankingFinancialInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Corporate Finance/ Investment"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.corporateFinance;
      } else {
        this.specializationSubCategories = DropdownData.corporateFinanceInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "General/ Cost Accounting"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.costAccounting;
      } else {
        this.specializationSubCategories = DropdownData.costAccountingInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Admin/Human Resources"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.humanResources;
      } else {
        this.specializationSubCategories = DropdownData.humanResourcesInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Advertising") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.advertising;
      } else {
        this.specializationSubCategories = DropdownData.advertisingInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Art/Creative Design"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.creativeDesign;
      } else {
        this.specializationSubCategories = DropdownData.creativeDesignInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Civil Engineering/Construction"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.civilEngineering;
      } else {
        this.specializationSubCategories = DropdownData.civilEngineeringInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Property/Real Estate"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.realEstate;
      } else {
        this.specializationSubCategories = DropdownData.realEstateInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "IT-Network/System/DB Admin"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.itNetwork;
      } else {
        this.specializationSubCategories = DropdownData.itNetworkInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "IT-Software") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.itSoftware;
      } else {
        this.specializationSubCategories = DropdownData.itSoftwareInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Education") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.education;
      } else {
        this.specializationSubCategories = DropdownData.educationInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Electrical Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.electricalEngineering;
      } else {
        this.specializationSubCategories = DropdownData.electricalEngineeringInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Electronic Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.electronicEngineering;
      } else {
        this.specializationSubCategories = DropdownData.electronicEngineeringInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization ==
      "Mechanical/Automotive Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.automotiveEngineering;
      } else {
        this.specializationSubCategories = DropdownData.automotiveEngineeringInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Oil/Gas Engineering"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.oilGasEngineering;
      } else {
        this.specializationSubCategories = DropdownData.oilGasEngineeringInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Nurse/Medical Support"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.medicalSupport;
      } else {
        this.specializationSubCategories = DropdownData.medicalSupportInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Food/Beverage/Restaurant"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.beverageRestaurant;
      } else {
        this.specializationSubCategories = DropdownData.beverageRestaurantInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Hotel/Tourism") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.hotelTourism;
      } else {
        this.specializationSubCategories = DropdownData.hotelTourismInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Maintenance") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.maintenance;
      } else {
        this.specializationSubCategories = DropdownData.maintenanceInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Manufacturing") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.manufacturing;
      } else {
        this.specializationSubCategories = DropdownData.manufacturingInMalay;
      }
    } else if (
      this.jobseekerEducation.specialization == "Purchasing/Material Management"
    ) {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.materialManagement;
      } else {
        this.specializationSubCategories = DropdownData.materialManagementInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Digital Marketing") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.digitalMarketing;
      } else {
        this.specializationSubCategories = DropdownData.digitalMarketingInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "E-commerce") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.eCommerce;
      } else {
        this.specializationSubCategories = DropdownData.eCommerceInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Biomedical") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.biomedical;
      } else {
        this.specializationSubCategories = DropdownData.biomedicalInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "Law/Legal Services") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.lawLegalServices;
      } else {
        this.specializationSubCategories = DropdownData.lawLegalServicesInMalay;
      }
    } else if (this.jobseekerEducation.specialization == "General Work") {
      if (this.selectedLanguage == "en") {
        this.specializationSubCategories = DropdownData.generalWork;
      } else {
        this.specializationSubCategories = DropdownData.generalWorkInMalay;
      }
    }
  }
  // For Education Ends

  back() {
    if (this.step == 3 && this.fresherStatus == true) {
      this.step -= 2;
    } else {
      this.step--;
    }
  }

  getAllSkills() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.ADMIN_PROVIDER,
    };
    UpSkillService.getAllSkills(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (response.data != undefined && response.data != null) {
            this.skillsListingData = response.data.data;
          }
        }
      }
    });
  }

  getCountry() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.ADMIN_PROVIDER,
    };
    UpSkillService.getCountry(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (response.data != undefined && response.data != null && response.data.data != undefined && response.data.data != null) {
            this.countryList = response.data.data.data;
          }
        }
      }
    });
  }
}
